import { defineComponent as _defineComponent } from 'vue'
import route from 'ziggy-js';
import { onMounted, reactive, ref } from 'vue';
import { router, usePage } from '@inertiajs/vue2';
import IconLogo from '@/components/icons/IconLogo.vue';
import BaseButton from '@/components/base/BaseButton.vue';
import ChoosePlanTable from '@/components/ChoosePlanTable.vue';
import CompanyRegisterForm from '@/components/CompanyRegisterForm.vue';
import type { SelectOption, OrganizationFormData, Incomplete, SubscriptionPlan } from '../types';


export default /*#__PURE__*/_defineComponent({
  __name: 'OrganizationView',
  props: {
    plans: { default: () => [] },
    countries: { default: () => [] },
    industries: { default: () => [] }
  },
  setup(__props: any) {



const formView = ref<'organization' | 'plan'>('organization');
const formData = reactive<Incomplete<OrganizationFormData>>({
    name: null,
    email: null,
    country: null,
    industry: null,
    website: null,
    phone: null,
    coupon: null,
    plan_id: null,
});

function handleOrganizationChange(data: Omit<OrganizationFormData, 'coupon' | 'plan_id'>) {
    formData.name = data.name;
    formData.email = data.email;
    formData.country = data.country;
    formData.industry = data.industry;
    formData.website = data.website;
    formData.phone = data.phone;

    formView.value = 'plan';
}

function handlePlanChoose(planId: OrganizationFormData['plan_id']) {
    formData.plan_id = planId;

    router.post(route('organization.store'), formData, {
        onError: () => {
            formView.value = 'organization';
        },
    });
}

const { props } = usePage();

onMounted(() => {
    formView.value = props.organization ? 'plan' : 'organization';
});

return { __sfc: true,formView, formData, handleOrganizationChange, handlePlanChoose, props, IconLogo, BaseButton, ChoosePlanTable, CompanyRegisterForm }
}

})